import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { canAccept } from '../../lib/rules'
import { faDigits } from '../../lib/numerals'
import Button from '../common/Button'

/**
 * «قوانین طوطی» (R13): the feed rules, accepted once — the server's own text,
 * verbatim, one box to tick and «ادامه». There is no way past it but
 * accepting: while the server posts every scored take, practising means
 * publishing. The version the server serves is shown at the bottom, so a
 * learner asked again after a wording change can see why.
 *
 * Presentational: the gate (`RulesGate` in App.jsx) and the practice page's
 * safety net both feed it, and the render test draws it with plain props.
 */
export default function RulesScreen({ text, version, busy = false, failed = false, compact = false, onAccept }) {
  const { t } = useTranslation('social')
  const [checked, setChecked] = useState(false)
  return (
    <section data-rules-screen className={compact ? 'flex flex-col gap-3' : 'mx-auto flex min-h-[70vh] max-w-md flex-col gap-4 px-4 py-6'}>
      <h1 className={compact ? 'text-base font-bold text-ink' : 'text-xl font-bold text-ink'}>{t('rules.title')}</h1>
      <p className="text-[13px] leading-relaxed text-ink-2">{t('rules.intro')}</p>
      <p className="whitespace-pre-line rounded-2xl bg-surface p-4 text-[13.5px] leading-[1.95] text-ink ring-1 ring-line">{text}</p>
      <label className="flex cursor-pointer items-start gap-3 rounded-xl bg-surface-2 p-3">
        <input
          type="checkbox"
          checked={checked}
          onChange={(event) => setChecked(event.target.checked)}
          className="mt-0.5 size-5 shrink-0 accent-brand-600"
        />
        <span className="text-sm font-semibold text-ink">{t('rules.checkbox')}</span>
      </label>
      {failed && <p className="rounded-xl bg-bad-tint px-3 py-2 text-xs text-bad-ink">{t('rules.failed')}</p>}
      <Button className="w-full" loading={busy} disabled={!canAccept({ checked, busy })} onClick={onAccept}>
        {t('rules.continue')}
      </Button>
      {version !== null && version !== undefined && (
        <p className="text-center text-[11px] text-ink-3">{t('rules.version', { version: faDigits(version) })}</p>
      )}
    </section>
  )
}
